module.exports = __webpack_public_path__ + "vue-dist/img/verify-failed.fa918016.png";